import { NamedDefinitionPage } from './NamedDefinitionPage';

export function ProducersPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/producers"
      listRoute="/producers"
      title="Üretici"
      subtitle="Üretici kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Üretici Kodu"
      descField="name"
      descOData="Name"
      descriptionLabel="Üretici Adı"
      descRequired
      newLabel="Yeni Üretici"
      exportName="ureticiler"
      entityLabel="üretici"
    />
  );
}
